/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'quote-trans': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<g transform="translate(1 .5)" _stroke="#376F99" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M8.554 6.282V8.84c-.092.79-.528 1.184-1.307 1.184H1.17C.389 9.934 0 9.459 0 8.595V2.337c.085-.528.475-.791 1.169-.791h2.607"/><circle pid="1" cx="7.724" cy="2.222" r="2.222"/></g>'
  }
})
